export const DELETED_USER_LABEL = 'Deleted User';
export const SYSTEM_CREATOR_LABEL = 'System';

export const getUserDisplayName = (userDetails) => userDetails?.full_name || userDetails?.email || '';

export const formatUserName = (userDetails) =>
  userDetails && !userDetails.email ? DELETED_USER_LABEL : getUserDisplayName(userDetails);

export const formatUserNameWithEmail = (userDetails) => {
  if (!userDetails?.email) {
    return DELETED_USER_LABEL;
  }

  if (!userDetails.full_name) {
    return userDetails.email;
  }

  return `${userDetails.full_name} (${userDetails.email})`;
};

export const formatCreatorNameWithEmail = (userDetails) =>
  userDetails ? formatUserNameWithEmail(userDetails) : SYSTEM_CREATOR_LABEL;
